import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { tap } from "rxjs/operators";
import { LoaderService } from "../../common/services/loader.service";
import { ContactService } from "../services/contacts.service";

@Injectable()
export class ChiefsOrderGetProfile {

    constructor(public loaderService: LoaderService,
        public contacts: ContactService) {

    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.loaderService.toggleLoader(true);        
        const contactProfile = this.contacts.getProfile().pipe(tap((data) => { this.loaderService.toggleLoader(false); }));
        return contactProfile;
    }
}